// extracted by mini-css-extract-plugin
export default {"wantedCard":"WantedCard_wantedCard__gqule","wantedCardItem":"WantedCard_wantedCardItem__uhuJz"};